import { faArrowRight } from '@fortawesome/pro-regular-svg-icons/faArrowRight'
import { faEllipsisVertical } from '@fortawesome/pro-regular-svg-icons/faEllipsisVertical'
import { ActionIcon, Flex, type FlexProps, Menu } from '@mantine/core'
import { useRouter } from 'next/router'

import { useTranslation } from '@flecto/translations'
import { Icon } from '@flecto/ui'

import type { ScheduleBooking } from '../../types/ScheduleBooking'

export type CellActionsProps = FlexProps & {
  booking: ScheduleBooking
}

export function CellActions({ booking, ...props }: CellActionsProps) {
  const router = useRouter()
  const { t } = useTranslation('saas', { keyPrefix: 'booking' })
  const { internal_id: id } = booking
  const bookingUrl = `/bookings/${id}`

  return (
    <Flex {...props} gap='xs' justify='flex-end'>
      <Menu withinPortal position='bottom-end'>
        <Menu.Target>
          <ActionIcon variant='default'>
            <Icon icon={faEllipsisVertical} />
          </ActionIcon>
        </Menu.Target>

        <Menu.Dropdown miw={230}>
          <Menu.Item
            rightSection={<Icon icon={faArrowRight} />}
            onClick={() => router.push(bookingUrl)}
          >
            {t('actions.go_to_booking')}
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
    </Flex>
  )
}
